import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "main-page" }
const _hoisted_2 = { class: "main-wallet" }
const _hoisted_3 = { class: "main-wallet__top" }
const _hoisted_4 = { class: "main-wallet__main-info" }
const _hoisted_5 = { class: "main-wallet__icon" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "main-wallet__info" }
const _hoisted_8 = { class: "main-wallet__sum" }
const _hoisted_9 = { class: "main-wallet__wallet" }
const _hoisted_10 = { class: "main-wallet__wallet-address for-copy" }
const _hoisted_11 = { class: "main-wallet__controls" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "text-capitalize-first" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "text-capitalize-first" }
const _hoisted_16 = { class: "main-wallet__numbers" }
const _hoisted_17 = { class: "main-wallet__number" }
const _hoisted_18 = { class: "main-wallet__number-info" }
const _hoisted_19 = { class: "main-wallet__number-title" }
const _hoisted_20 = { class: "main-wallet__number-summ" }
const _hoisted_21 = { class: "main-wallet__number" }
const _hoisted_22 = { class: "main-wallet__number-info" }
const _hoisted_23 = { class: "main-wallet__number-title text-capitalize-first" }
const _hoisted_24 = { class: "main-wallet__number-summ" }
const _hoisted_25 = { class: "main-wallet__percents" }
const _hoisted_26 = { class: "main-wallet__percents-title" }
const _hoisted_27 = { class: "main-wallet__percents-title" }
const _hoisted_28 = { class: "text-capitalize-first" }
const _hoisted_29 = { class: "main-wallet__percents-list" }
const _hoisted_30 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_31 = { class: "text-muted" }
const _hoisted_32 = { class: "small" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 2 }
const _hoisted_36 = {
  key: 0,
  class: "main-wallet__percents"
}
const _hoisted_37 = { class: "main-wallet__percents-title" }
const _hoisted_38 = { class: "main-wallet__percents-title" }
const _hoisted_39 = { class: "text-capitalize-first" }
const _hoisted_40 = { class: "main-wallet__percents-list" }
const _hoisted_41 = { class: "d-flex gap-sm" }
const _hoisted_42 = {
  key: 0,
  class: "main-deals"
}
const _hoisted_43 = { class: "main-deals__item" }
const _hoisted_44 = { class: "main-deals__title" }
const _hoisted_45 = { class: "main-deals__sum" }
const _hoisted_46 = { class: "main-deals__summery" }
const _hoisted_47 = { class: "main-deals__deals-count" }
const _hoisted_48 = { class: "main-deals__canceled-count" }
const _hoisted_49 = { class: "main-deals__item" }
const _hoisted_50 = { class: "main-deals__title" }
const _hoisted_51 = { class: "main-deals__sum" }
const _hoisted_52 = { class: "deals" }
const _hoisted_53 = { class: "active-disputes" }
const _hoisted_54 = { class: "active-disputes__title" }
const _hoisted_55 = { class: "text-capitalize-first" }
const _hoisted_56 = {
  key: 0,
  class: "deals"
}
const _hoisted_57 = { class: "main-item deal" }
const _hoisted_58 = { class: "table align-middle text-left text-nowrap position-relative" }
const _hoisted_59 = { class: "" }
const _hoisted_60 = { style: {"width":"0"} }
const _hoisted_61 = { class: "text-capitalize-first main-wallet__percents-title" }
const _hoisted_62 = {
  key: 0,
  class: "main-wallet__percents-title"
}
const _hoisted_63 = {
  class: "p-sm",
  style: {"text-align":"right"}
}
const _hoisted_64 = { style: {"white-space":"nowrap"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CopyButton = _resolveComponent("CopyButton")!
  const _component_DealsSection = _resolveComponent("DealsSection")!
  const _component_b_progress_bar = _resolveComponent("b-progress-bar")!
  const _component_b_progress = _resolveComponent("b-progress")!
  const _component_AccountOperationPopup = _resolveComponent("AccountOperationPopup")!
  const _component_WithdrawalPopup = _resolveComponent("WithdrawalPopup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (account) => {
          return (_openBlock(), _createElementBlock("div", {
            key: account.id
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    src: _ctx.helper.currencyIcon(account.currency)
                  }, null, 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatNumber(account.sumWithoutInsurance)), 1),
                    _createTextVNode(" " + _toDisplayString(account.currency), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(account._wallet ? _ctx.truncateAddress(account._wallet.address) : ''), 1),
                    _cache[0] || (_cache[0] = _createElementVNode("span", null, "(USDT TRC20)", -1)),
                    _createVNode(_component_CopyButton, {
                      value: account._wallet?.address
                    }, null, 8, ["value"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_ctx.isTrader)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "#",
                      onClick: _withModifiers(($event: any) => (_ctx.showWithdrawal(account)), ["prevent"]),
                      class: "btn main-wallet__btn"
                    }, [
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('button.withdraw')), 1)
                    ], 8, _hoisted_12))
                  : _createCommentVNode("", true),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _withModifiers(($event: any) => (_ctx.showHistory(account)), ["prevent"]),
                  class: "btn main-wallet__btn"
                }, [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('button.history')), 1)
                ], 8, _hoisted_14)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "main-wallet__number-icon" }, [
                  _createElementVNode("svg", {
                    width: "30",
                    height: "30",
                    viewBox: "0 0 30 30",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M14.4915 3.3555C14.6344 3.23694 14.8143 3.17206 15 3.17206C15.1857 3.17206 15.3656 3.23694 15.5085 3.3555C18.5049 5.84798 22.2323 7.29563 26.1255 7.479C26.3009 7.4844 26.4689 7.55115 26.6002 7.66764C26.7315 7.78412 26.8178 7.94296 26.844 8.1165C26.9475 8.8965 27 9.6915 27 10.5015C27 18.2445 22.11 24.846 15.249 27.3855C15.0883 27.4447 14.9117 27.4447 14.751 27.3855C7.89 24.846 3 18.2445 3 10.5C3 9.693 3.0525 8.8965 3.156 8.1165C3.18229 7.94271 3.26878 7.78368 3.40038 7.66717C3.53197 7.55065 3.70031 7.48405 3.876 7.479C7.76891 7.29488 11.4957 5.84822 14.4915 3.3555ZM20.7855 12.2865C20.9609 12.045 21.0333 11.7437 20.9866 11.4489C20.9399 11.1541 20.778 10.8899 20.5365 10.7145C20.295 10.5391 19.9937 10.4667 19.6989 10.5134C19.4041 10.5601 19.1399 10.722 18.9645 10.9635L13.74 18.1485L10.92 15.3285C10.8162 15.2211 10.692 15.1355 10.5547 15.0766C10.4174 15.0177 10.2698 14.9867 10.1204 14.9855C9.97104 14.9842 9.82291 15.0128 9.68468 15.0694C9.54645 15.126 9.42088 15.2096 9.3153 15.3153C9.20972 15.421 9.12625 15.5466 9.06975 15.6849C9.01325 15.8232 8.98485 15.9714 8.98622 16.1207C8.98759 16.2701 9.01869 16.4177 9.07772 16.5549C9.13674 16.6922 9.2225 16.8163 9.33 16.92L13.08 20.67C13.1949 20.785 13.3334 20.8737 13.486 20.9301C13.6385 20.9864 13.8014 21.009 13.9635 20.9963C14.1256 20.9836 14.283 20.9359 14.4249 20.8566C14.5668 20.7772 14.6899 20.668 14.7855 20.5365L20.7855 12.2865Z",
                      fill: "#00A3FB"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('labels.insurance_limit')) + ": ", 1),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.numberFormatter.formatNumber(account.insuranceSum.amount, 2)) + " / " + _toDisplayString(_ctx.numberFormatter.formatNumber(account.insuranceLimitSum.amount, 2)) + " " + _toDisplayString(account.insuranceLimitSum.currency), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "main-wallet__number-icon" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 139.186 16.8 21.52",
                    width: "16.8px",
                    height: "21.52px"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M 4.6 148.706 L 2.8 148.706 L 2.4 148.706 C 1.763 148.706 1.153 148.959 0.703 149.409 C 0.253 149.859 0 150.47 0 151.106 L 0 158.306 C 0 158.943 0.253 159.553 0.703 160.003 C 1.153 160.453 1.763 160.706 2.4 160.706 L 14.4 160.706 C 15.036 160.706 15.647 160.453 16.097 160.003 C 16.547 159.553 16.8 158.943 16.8 158.306 L 16.8 151.106 C 16.8 150.47 16.547 149.859 16.097 149.409 C 15.647 148.959 15.036 148.706 14.4 148.706 L 4.6 148.706 Z",
                      fill: "#00A3FB",
                      style: {"stroke-width":"1"},
                      transform: "matrix(1, 0, 0, 1, -3.552713678800501e-15, 0)"
                    }),
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M 8.402 139.186 C 6.97 139.186 5.596 139.755 4.583 140.768 C 3.571 141.78 3.002 143.154 3.002 144.586 L 3.002 148.786 L 4.802 148.786 L 4.802 144.586 C 4.802 143.631 5.181 142.716 5.856 142.04 C 6.531 141.365 7.447 140.986 8.402 140.986 C 9.357 140.986 10.272 141.365 10.947 142.04 C 11.623 142.716 12.002 143.631 12.002 144.586 L 11.992 148.714 C 12.005 148.739 13.844 148.796 13.822 148.784 L 13.802 144.586 C 13.802 143.877 13.662 143.175 13.391 142.52 C 13.119 141.864 12.722 141.269 12.22 140.768 C 11.719 140.266 11.124 139.868 10.468 139.597 C 9.813 139.326 9.111 139.186 8.402 139.186 Z",
                      fill: "#00A3FB",
                      style: {"stroke-width":"1"},
                      transform: "matrix(1, 0, 0, 1, -3.552713678800501e-15, 0)"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('dashboard.on_hold')) + ": ", 1),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.numberFormatter.formatNumber(account.frozenSum)) + " " + _toDisplayString(account.sum.currency), 1)
                ])
              ])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t("dashboard.trade_reward")), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList({'in':_ctx.payInRewardFee, 'out': _ctx.payOutRewardFee}, (rewardSettings, direction) => {
            return (_openBlock(), _createElementBlock("div", null, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t(`direction.${direction}`)) + ":", 1)
              ]),
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rewardSettings, (settings) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "main-wallet__percents-item",
                    key: settings.name
                  }, [
                    _createElementVNode("div", null, [
                      _createElementVNode("b", null, _toDisplayString(settings.name) + ":", 1),
                      _cache[3] || (_cache[3] = _createTextVNode()),
                      _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(settings.reward), 1)) + "%", 1),
                      _cache[4] || (_cache[4] = _createTextVNode()),
                      (settings.additional)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: _normalizeClass(parseFloat(settings.additional) > 0 ? 'text-success' : '')
                          }, _toDisplayString(parseFloat(settings.additional) > 0 ? '+' : '') + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(settings.additional), 1)) + "%", 3))
                        : _createCommentVNode("", true)
                    ]),
                    (settings.traderFeeByDealAmount && settings.traderFeeByDealAmount.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createElementVNode("small", _hoisted_31, _toDisplayString(_ctx.$t('labels.fee_ranges')), 1),
                          _createElementVNode("div", _hoisted_32, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(settings.traderFeeByDealAmount, (range, index) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: index,
                                class: "me-2"
                              }, [
                                (range.minSum && range.maxSum)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.minSum.toString()) / 100, 2)) + " - " + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.maxSum.toString()) / 100, 2)) + " " + _toDisplayString(range.currency) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.fee), 1)) + "% ", 1))
                                  : (range.minSum)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, " ≥" + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.minSum.toString()) / 100, 2)) + " " + _toDisplayString(range.currency) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.fee), 1)) + "% ", 1))
                                    : (range.maxSum)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_35, " ≤" + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.maxSum.toString()) / 100, 2)) + " " + _toDisplayString(range.currency) + ": " + _toDisplayString(_ctx.numberFormatter.formatNumber(parseFloat(range.fee), 1)) + "% ", 1))
                                      : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          }), 256))
        ]),
        (_ctx.currencyRatesByGroups.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t("labels.currency_rates")), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList({'in':_ctx.currencyRatesByGroups.filter(item =>item.direction === 'in'), 'out': _ctx.currencyRatesByGroups.filter(item =>item.direction === 'out')}, (currencyRates, direction) => {
                return (_openBlock(), _createElementBlock("div", null, [
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t(`direction.${direction}`)) + ":", 1)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currencyRates, (settings) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "main-wallet__percents-item",
                        key: settings.name
                      }, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("b", null, _toDisplayString(settings.name) + ":", 1),
                          _cache[5] || (_cache[5] = _createTextVNode()),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(settings.currencyRates, (item, index) => {
                            return (_openBlock(), _createElementBlock("span", { key: index }, _toDisplayString(_ctx.numberFormatter.formatMoney(item.rate)), 1))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              }), 256))
            ]))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([_ctx.todayPayInStats, _ctx.todayPayOutStats], (todayStat) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          todayStat
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.$t(`labels.today_stat.deals.${todayStat.type}`)), 1),
                  todayStat
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(todayStat.items, (item) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatMoney(item.completedTakerSum)) + " ", 1),
                            _createElementVNode("sup", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatMoney(item.completedMakerSum, 2)), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("span", _hoisted_47, [
                              _createTextVNode(_toDisplayString(_ctx.$t('labels.today_completed')) + ": ", 1),
                              _createElementVNode("span", null, _toDisplayString(item.completedCount), 1)
                            ]),
                            _createElementVNode("span", _hoisted_48, [
                              _createTextVNode("  " + _toDisplayString(_ctx.$t('labels.today_canceled')) + ": ", 1),
                              _createElementVNode("span", null, _toDisplayString(item.canceledCount), 1)
                            ])
                          ])
                        ], 64))
                      }), 256))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.$t(`labels.today_stat.rewards.${todayStat.type}`)), 1),
                  todayStat
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(todayStat.items, (item) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_51, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.numberFormatter.formatMoney(item.rewardSum, 2)) + " ", 1)
                        ]))
                      }), 256))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256)),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.$t('labels.active_disputes')), 1)
          ]),
          _createVNode(_component_DealsSection, {
            "hide-header": true,
            ref: "activeDisputesSection"
          }, null, 512)
        ])
      ]),
      (_ctx.onlineAmountsStats.options && _ctx.onlineAmountsStats.options?.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("table", _hoisted_58, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_59, [
                    _createElementVNode("th", _hoisted_60, [
                      _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.$t('labels.sum')), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlineAmountsStats.options, (option) => {
                      return (_openBlock(), _createElementBlock("th", {
                        style: _normalizeStyle({'width': (100 / _ctx.onlineAmountsStats.options.length) + '%'}),
                        key: option,
                        class: "text-capitalize"
                      }, [
                        option
                          ? (_openBlock(), _createElementBlock("span", _hoisted_62, _toDisplayString(_ctx.helper.trans(`payment_options.${option}`)), 1))
                          : _createCommentVNode("", true)
                      ], 4))
                    }), 128))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlineAmountsStats.stat, (stat, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", _hoisted_63, [
                        _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.numberFormatter.formatNumber(stat.min)) + " - " + _toDisplayString(_ctx.numberFormatter.formatNumber(stat.max)), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onlineAmountsStats.options, (option) => {
                        return (_openBlock(), _createElementBlock("td", {
                          key: option,
                          class: "p-sm"
                        }, [
                          _createVNode(_component_b_progress, {
                            max: "100",
                            class: "position-relative stat-progress-bar"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_progress_bar, {
                                value: parseInt(stat.stats[option]?.percent),
                                style: _normalizeStyle({background: _ctx.getProgressBackground(stat.stats[option]?.percent)}),
                                class: ""
                              }, null, 8, ["value", "style"]),
                              _cache[6] || (_cache[6] = _createElementVNode("small", { class: "justify-content-center d-flex position-absolute w-100" }, null, -1))
                            ]),
                            _: 2,
                            __: [6]
                          }, 1024)
                        ]))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_AccountOperationPopup, { ref: "accountOperationPopup" }, null, 512),
    _createVNode(_component_WithdrawalPopup, { ref: "withdrawalPopup" }, null, 512)
  ], 64))
}